/**
 * convert a array to array of chunks
 */

type ArrayArrays = any[][];

const arrayToArrays = (arr: [], size: number): ArrayArrays =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_v, i) =>
    arr.slice(i * size, i * size + size)
  );

export { arrayToArrays };
